<div [class.loader-hidden]="!show" class="loader-background">
    <div class="loader-overlay">
        <img [src]="image" style="width:100px; height:100px">
    </div>
</div>